import React from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn, getUserRole } from "../../../utils/authHelpers";
import { FaHome, FaArrowLeft } from "react-icons/fa";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const getHomeRoute = (): string => {
    if (!isLoggedIn()) {
      return "/";
    }

    const userRole = getUserRole();

    if (userRole === "admin" || userRole === "super_admin") {
      return "/admin/dashboard";
    }

    return "/dashboard";
  };

  const handleReturnHome = () => {
    navigate(getHomeRoute());
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 bg-gray-50">
      <div className="w-full max-w-lg text-center space-y-8">
        {/* 404 Header */}
        <h1 className="text-9xl font-extrabold text-gray-7">404</h1>

        {/* Message */}
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-gray-7">Page Not Found</h2>
          <p className="text-xl text-gray-5">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-7 border-2 border-gray-7 rounded-lg font-semibold hover:bg-gray-100 transition-colors w-full sm:w-auto"
          >
            <FaArrowLeft className="text-lg" />
            Go Back
          </button>

          <button
            onClick={handleReturnHome}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-7 text-white rounded-lg font-semibold hover:bg-gray-6 transition-colors w-full sm:w-auto"
          >
            <FaHome className="text-lg" />
            Return Home
          </button>
        </div>

        {/* Help text */}
        <p className="text-gray-5 mt-8">
          If you think this is an error, please{" "}
          <a
            href="mailto:support@unspokenn.com"
            className="text-gray-7 underline font-semibold"
          >
            contact support
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
